/** Subscription statuses that indicate payment has failed (show payment-failed banners). */
export const SUBSCRIPTION_PAYMENT_FAILED_STATUSES: readonly string[] = [
  'past_due',
  'unpaid',
  'PAST_DUE',
  'UNPAID',
];

export function isSubscriptionPaymentFailed(status: string | undefined): boolean {
  return !!status && SUBSCRIPTION_PAYMENT_FAILED_STATUSES.includes(status);
}

export const getSubscriptionStatusKey = (status: string): string => {
  switch (status?.toUpperCase()) {
    case 'ACTIVE':
      return 'subscription.status.active';
    case 'CANCELED':
    case 'CANCELLED':
      return 'subscription.status.canceled';
    case 'PAST_DUE':
      return 'subscription.status.past_due';
    case 'UNPAID':
      return 'subscription.status.unpaid';
    case 'INCOMPLETE':
      return 'subscription.status.incomplete';
    case 'INCOMPLETE_EXPIRED':
      return 'subscription.status.incomplete_expired';
    case 'TRIALING':
      return 'subscription.status.trialing';
    default:
      return 'subscription.status.unknown';
  }
};
